import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
import { useGetTranslations } from '@/composables/useGetTranslations';
import { recipeIngredientsStore } from '@/store/RecipeIngredientsStore';
export default {
  name: 'BalanceSelector',
  components: {
    AzIcon: AzIcon
  },
  props: {
    balanceOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup(props) {
    var _useGetTranslations = useGetTranslations(),
      translate = _useGetTranslations.translate;
    var store = recipeIngredientsStore;
    var currentBalance = ref(store.balanceOption);
    var filteredQuantityOptions = computed(function () {
      return props.balanceOptions.filter(function (option) {
        return option && option.code != store.balanceOption.code;
      });
    });
    return {
      filteredQuantityOptions: filteredQuantityOptions,
      translate: translate,
      currentBalance: currentBalance
    };
  }
};